<h2 mat-dialog-title>User List</h2>

<span mat-dialog-close class="btn-mat-dialog-close">
    <img src="assets/images/close-icon-gray.svg" alt="Close" title="Close" />
</span>


<mat-dialog-content>

    <div class="custom-search-bar float-end">
        <mat-form-field appearance="fill">
            <input matInput type="search" placeholder="Search User" [formControl]="searchControl">
        </mat-form-field>
        <!-- <button mat-icon-button aria-label="Search">
            <mat-icon>search</mat-icon>
        </button> -->
    </div>


    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)">

        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name"> Name </th>
            <td mat-cell *matCellDef="let element"> {{element.userDetails.firstName + ' ' +
                element.userDetails.lastName}} </td>
        </ng-container>

        <!-- Role Column -->
        <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by role"> Role </th>
            <td mat-cell *matCellDef="let element"> {{element?.roles?.name}} </td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by action"> Action </th>
            <td mat-cell *matCellDef="let element">
                <button mat-button class="btn-switch-account" (click)="switchUser(element)">
                    <img src="./assets/images/edit-icon-blue.svg" alt="" />
                    {{element.action}}
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>